<mat-dialog-content>
  <h2 class="text-center">{{ header }}</h2>
</mat-dialog-content>
<eq-seperator></eq-seperator>
<div class="d-flex row justify-content-center m-0 p-0">
  <div class="col-10" [class.mb-3]="!warn">
    <div class="row">
      <div class="col vertical-seprator justify-content-center text-center">
        <button mat-button mat-dialog-close color="primary" type="button" class="back-btn">
          <span class="px-4" style="color: #007297">{{rejectLabel}}</span>
        </button>
      </div>

      <div class="col justify-content-center text-center">
        <button mat-flat-button color="primary" [mat-dialog-close]="'delete'" class="next-btn">
          <span class="px-4 submit-btn-label">{{ acceptLabel }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
<eq-seperator *ngIf="warn"></eq-seperator>
<div class="d-flex p-2" *ngIf="warn">
  <span class="d-flex justify-content-center align-items-center mx-2 warn-message-icon"><mat-icon>warning_amber</mat-icon></span>
  <span class="warn-message">{{warn}}</span>
</div>